import React from 'react';
import Parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { Link, Spinner } from '../../components/ui';

import useScreenTitle from '../../common/use-screen-title';
import usePoliciesFetcher from '../../common/use-policies-fetcher';

import './policies.scss';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  useScreenTitle(t('sidebar.privacy_policy'));

  const { policies, isFetching } = usePoliciesFetcher();

  return (
    <div className="page policies">
      {isFetching ? (
        <Spinner />
      ) : (
        <div className="container">
          <h1>{t('sidebar.privacy_policy')}</h1>

          {policies.privacy_format === 'text' ? (
            Parser(policies.privacy)
          ) : policies.privacy_link ? (
            <Link href={policies.privacy_link} target="_blank">
              {policies.privacy_link}
            </Link>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;
